import * as _ from 'lodash';
import { Fragment } from 'react';
import CartItem from '../pos/cart/CartItem.react';
import Price from '../form/Price.react';
import AjaxPromises from '../../utils/AjaxPromises';

import GuestStore from '../../stores/GuestStore';
import UserStore from '../../stores/UserStore';
import ConfigStore from '../../stores/ConfigStore';
import UserApi from '../../api/UserApi';

import { endPoints as PosEndPoints } from '../../constants/PosCartConstants';


class CartDisplay extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            items: [],
            appliedLoyaltyPoints: 0,
            appliedFeesDonations: [],
            guest: {},
            timer: null,
            features: {},
            subTotal: 0,
            totalDiscountAndLoyalty: 0,
            tax: 0,
            feesDonations: 0,
            grandTotal: 0,
            grandTotalRounded: 0,
        };

        this.onGuestStoreChange = this.onGuestStoreChange.bind(this);
        this.loadCart = this.loadCart.bind(this);
        this.loadFeatures = this.loadFeatures.bind(this);
    }

    componentDidMount() {
        GuestStore.addChangeListener(this.onGuestStoreChange);    
        
        this.loadFeatures();

    }

    componentWillUnmount() {
        GuestStore.removeChangeListener(this.onGuestStoreChange);
    }

    loadFeatures() {

        if(window.location.href.split('-').length > 3) {

            let dashIndex = window.location.href.lastIndexOf('-');
            let locId = window.location.href.slice(dashIndex + 1);
            let data = UserStore.getApiData();
            data.LocId = locId;
            UserApi.getLocationSettings(data).then(res => {
                let locProfileConverted = {};
                _.map(res.Data.Features, (feature) => {
                    locProfileConverted[feature.FeatureName] = feature.IsEnabled;
                });
                this.setState({ features: locProfileConverted });

                this.loadCart();
            })
        } else {
            this.loadCart();
        }
        
    }

    loadCart() {
        let data = UserStore.getApiData();
        data.Register = window.location.pathname.split('-')[2];

        AjaxPromises.POST(PosEndPoints.LOAD_CART_DISPLAY, data).then(x => {
            if(x.Result) {

                if(x.Data) {
                    let data = JSON.parse(x.Data);
                    this.setState({
                        items: data.Cart,
                        appliedLoyaltyPoints: data.Loyalty.AppliedLoyaltyPoints,
                        appliedFeesDonations : data.FeesDonations || [],
                        subTotal: data.SubTotal,
                        totalDiscountAndLoyalty: data.TotalDiscountAndLoyalty,
                        tax: data.Tax,
                        feesDonations: data.FeesAndDonations,
                        grandTotal: data.GrandTotal,
                        grandTotalRounded: data.GrandTotalRounded
                    });
                } else {
                    this.setState({
                        items: [],
                        appliedLoyaltyPoints: 0,
                    });
                }
            }

            if(!!data.Cart) {
                setTimeout(this.loadCart, 2000);
            } else {
                setTimeout(this.loadCart, 7000);
            }



        }).catch(x => {
            setTimeout(this.loadCart, 7000);
        });
    }

    onGuestStoreChange() {
        this.setState({ guest: GuestStore.guest });
    }


    render() {
        let cart = this.state.items;
        let subtotal = this.state.subTotal;
        let discount = this.state.totalDiscountAndLoyalty;
        let appliedFDsAmt  = this.state.feesDonations;
        let tax = this.state.tax;
        let total = this.state.grandTotalRounded;

        return (<div className='cart'>

                <div className='pos-search__content'>

                    <div className='pos-search__results'>

                        <div className='pos-search__header'>
                            <div className='pos-search__header--qty'>
                                Qty
                            </div>
                            <div className='pos-search__header--desc'>
                                Description
                            </div>
                            <div className='pos-search__header--price'>
                                Price
                            </div>
                            <div className='pos-search__header--discount'>
                                Discount
                            </div>
                            <div className='pos-search__header--weight'>
                                Weight
                            </div>
                        </div>

                        { cart.map((item, i) => {
                            return (
                                <div
                                    className={'pos-search__item tgle '+(i % 2 ? 'pos-search__item--grey' : '')}
                                    id={i}>

                                    <div className='pos-search__item--qty tgle'>
                                        {item.QtySelected}
                                    </div>

                                    <div className='cart-item__item--desc tgle'
                                        title={item.Product}>
                                        {item.Product}
                                    </div>
                                    <div className='cart-item__item--serial tgle'
                                        title={item.SerialNo}>
                                        {item.SerialNo}
                                    </div>

                                    <div className='pos-search__item--price tgle'>
                                        <Price price={item.TotalCost} dollar className='tgle' />
                                    </div>

                                    <div className='pos-search__item--discount tgle'>
                                        <Price price={item.DiscountAmt} dollar className='tgle' />
                                    </div>

                                    <div className='pos-search__item--weight tgle'>
                                        {item.Equivalent}g
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    <div className='pos-cart-print' id='PrintCart'>
                        <div className='pos-cart-print__header'>
                            <span className='pos-cart-print__title'>Item</span>
                            <span>qty</span>
                        </div>

                        { cart.map((item, i) => {

                            return (
                                <div className='pos-cart-print__row'>
                                    <span className='pos-cart-print__title'>
                                        {item.Product}
                                        <br />
                                        <span>{item.SerialNo}</span>
                                    </span>
                                    <span>
                                        {item.QtyAllocated}
                                    </span>
                                </div>
                            );
                        })}

                    </div>

                </div>
                <div className='cart-summary'>

                <div className='cart-summary__totals'>

                    <div className='cart-summary__totals--left'>
                        SUB-TOTAL
                    </div>
                    <Price
                        className='cart-summary__totals--right'
                        price={subtotal}
                        dollar={true} />

                    <div className='cart-summary__totals--left'>
                        TOTAL DISCOUNT & LOYALTY
                    </div>
                    <Price
                        className='cart-summary__totals--right'
                        price={discount}
                        dollar={true} />

                    <div className='cart-summary__totals--left'>
                        TAX
                    </div>
                    <Price
                        className='cart-summary__totals--right'
                        price={tax}
                        dollar={true} />

                    { this.state.features.UseFeesDonations &&
                        <Fragment>
                            <div className='cart-summary__totals--left'>
                                {'FEES & DONATIONS'}
                            </div>
                            <Price
                                className='cart-summary__totals--right'
                                price={appliedFDsAmt}
                                dollar={true} />
                        </Fragment>
                    }
                    
                    <div className='cart-summary__totals--left'>
                        Total
                    </div>
                    <Price
                        className='cart-summary__totals--right'
                        price={total}
                        dollar={true} />
                </div>
                </div>
                </div>
                );
    }

}

export default CartDisplay;


// WEBPACK FOOTER //
// ./ui_src/app/components/cart-display/CartDisplay.react.jsx